import { Progress, Spinner } from "@heroui/react";
import React, { useRef } from "react";
import Banner from "../components/Banner";
import { EntityProvider, useEntityContext } from "../context/EntityContext";
import FileUploadGrid from "../components/FileUploadGrid";
import { useEffect, useState } from "react";
import { fetchInitialGridData } from "../utils/fetchInitialGridData";
import { toast } from "react-toastify";
import { DocMetaData } from "../utils/docMetaData";
import { UploadButton } from "../components/UploadButton";
import { previewFile } from "../utils/previewFile";


const loadingMessages = [
    "Loading grid data...",
    "Ingesting files...",
    "Almost done...",
];

const Ingestion: React.FC = () => {

    const [filesMeta, setFilesMeta] = useState<DocMetaData[]>([]);
    const [preLoading, setPreLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploading, setUploading] = useState(false);
    const [loadingStage, setLoadingStage] = useState(0);

    const startTimeRef = useRef<number | null>(null);
    const timerRef = useRef<NodeJS.Timeout>();

    const [previewLoading, setPreviewLoading] = useState(false);
    const [previewFileName, setPreviewFileName] = useState<string | null>(null);


    const { entityMap } = useEntityContext();

    const handleFilePreview = async (fileName: string, fileUrl: string) => {
        setPreviewFileName(fileName);
        setPreviewLoading(true);
        try {
            await previewFile(fileUrl, fileName);
        } catch (error) {
            console.log("Preview failed,", error);
        } finally {
            setPreviewLoading(false);
            setPreviewFileName(null);
        }
    };
    -
        //Fetch initial grid data

        useEffect(() => {

            // let stageTimer: NodeJS.Timeout;

            const loadInitialGrid = async () => {
                try {
                    setPreLoading(true);
                    setLoadingStage(0);
                    startTimeRef.current = Date.now();

                    const initialDataPromise = fetchInitialGridData();

                    const estimateTimer = () => {
                        timerRef.current = setInterval(() => {
                            const now = Date.now();
                            const elapsed = now - (startTimeRef.current || now);
                            const estimatedTotal = 3000;

                            const progress = Math.min(1, elapsed / estimatedTotal);
                            const stage = Math.min(2, Math.floor(progress * 3));
                            setLoadingStage(stage);
                        }, 1000);
                    };

                    estimateTimer();

                    const initialData = await initialDataPromise;



                    // stageTimer = setInterval(() => {
                    //     setLoadingStage((prev) => (prev < 2 ? prev + 1 : 2));
                    // }, 3000);



                    // const initialData = await fetchInitialGridData();

                    if (!Array.isArray(initialData) || initialData.length === 0) {
                        toast.info("No records found.");
                        setFilesMeta([]);
                    } else {
                        setFilesMeta(initialData)
                    }

                } catch {
                    toast.error("Failed to load grid data");
                    setFilesMeta([]);
                } finally {
                    clearInterval(timerRef.current as NodeJS.Timeout);
                    // clearInterval(stageTimer);
                    setPreLoading(false);
                    setLoadingStage(0);
                    startTimeRef.current = null;
                }
            };

            loadInitialGrid();
        }, []);

    console.log("preloading value is ", preLoading)
    return (
        <EntityProvider>
            <Banner current="ingestion" />
            <div data-testid="ingestion-page" className="p-6 max-w-screen-xl mx-auto">
                <h1 className="text-2xl font-bold text-start">
                    Ingested Documents
                </h1>
                {/* </div> */}
                {/* <div className=" p-6 max-w-screen-xl mx-auto "> */}
                <div className="mb-4 flex justify-end">
                    <UploadButton
                        filesMeta={filesMeta}
                        entityMap={entityMap}
                        setFilesMeta={setFilesMeta}
                        uploading={uploading}
                        setUploading={setUploading}
                        setUploadProgress={setUploadProgress}
                        endpoint="/uploader/upload"
                        uploadMode="confirm"
                        label="Confirm"
                    />

                </div>


                {preLoading ? (
                    <div className="mt-2">

                        <div className="flex flex-col items-center gap-2 text-blue-600 text-md">
                            <Spinner size="lg" color="secondary" />
                            <p className="mt-2 text-md">{loadingMessages[loadingStage]}</p>
                            <p className="text-sm text-gray-500 mt-1">Please wait while we set up your files..!</p>
                        </div>
                    </div>
                   
                ) : (
                    <>
                        {uploading && (
                            <div className="my-4">
                                <Progress
                                    size="md"
                                    radius="sm"
                                    label="Submitting response..."
                                    value={uploadProgress}
                                    maxValue={100}
                                    color="secondary"
                                    showValueLabel
                                />
                            </div>
                        )}

                        {previewLoading && previewFileName && (
                            <div className="fixed inset-0 bg-white/60 backdrop-blur-sm z-50 flex items-center justify-center">
                                <div className="bg-white border border-gray-300 shadow-xl px-6 py-4 rounded-lg flex items-center gap-3">

                                    <div className="animate-spin h-5 w-5 border-t-2 border-gray-600 rounded-full"></div>
                                    <div className="text-sm text-gray-800">
                                        Opening preview for <strong>{previewFileName}</strong>...
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="mt-4">
                            <FileUploadGrid rowData={filesMeta}
                                setRowData={setFilesMeta}
                                onFilePreviewClick={handleFilePreview}
                            />
                        </div>


                    </>
                )}
                

            </div>

        </EntityProvider>


    );

};

export default Ingestion;
